export default {"src":"/_next/static/media/password-hidden.65e03aa7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};